/*
  Similar to `custom-dropdown` controller but using Popover API.
  Uses Popper.js for anchor positioning. It hides the menu until popover
  finishes positioning to avoid flash of unstyled content.

  Usage example:

  <div data-controller="dropdown">
    <button type="button" data-dropdown-target="trigger">
      Toggle
    </button>

    <div data-dropdown-target="popover">
      Dropdown content
    </div>
  </div>
*/
import { Controller } from "@hotwired/stimulus"
import { createPopper } from "@popperjs/core"

export default class extends Controller {
  static targets = ["trigger", "popover"]

  static values = {
    placement: { type: String, default: "bottom-start" },
    offset: { type: Array, default: [0, 8] }
  }

  connect() {
    this.popoverTarget.popover = "auto"
    this.triggerTarget.popoverTargetElement = this.popoverTarget
    this.triggerTarget.popoverTargetAction = "toggle"
  }

  disconnect() {
    this.destroyPopper()
  }

  position(event) {
    const isOpen = event.newState === "open"
    this.triggerTarget.setAttribute("aria-expanded", isOpen)

    if (isOpen) {
      this.createPopper()
    } else {
      this.destroyPopper()
    }
  }

  createPopper() {
    if (this.popper) return

    this.popper = createPopper(this.triggerTarget, this.popoverTarget, {
      placement: this.placementValue,
      modifiers: [
        {
          name: "offset",
          options: {
            offset: this.offsetValue
          }
        }
      ]
    })
  }

  destroyPopper() {
    if (!this.popper) return

    this.popper.destroy()
    this.popper = null
  }
}
